export function never(param: never): never {
    throw new Error('This never happens (' + param + ')');
}
